import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { certificateSend } from 'api/payroll/prove-download';
export default {
  data: function data() {
    return {
      loading: false,
      // 发送loading
      visible: false,
      // 组件visible
      selectEmail: '',
      // 选项邮箱
      email: '',
      // 邮箱
      optionsEmail: [],
      // 邮箱选项
      cInfo: {} // 当前信息
    };
  },

  computed: {
    // 邮箱取值逻辑
    sendEmail: function sendEmail() {
      var selectEmail = this.selectEmail,
        email = this.email;
      if (selectEmail !== 3) return selectEmail;
      return email;
    }
  },
  methods: {
    init: function init(target) {
      if (!target) return;
      this.cInfo = target;
      this.visible = true;
      this.selectEmail = '';
      this.email = '';
      this.optionsEmail = [];
      target.enterprise_email && this.optionsEmail.push(target.enterprise_email);
      target.personal_email && this.optionsEmail.push(target.personal_email);
    },
    // 发送
    send: function send() {
      var _this = this;
      this.loading = true;
      certificateSend(_objectSpread(_objectSpread({}, this.cInfo), {}, {
        email: this.sendEmail
      })).then(function (res) {
        _this.visible = false;
        _this.$message.success(_this.$t('1880'));
      }).finally(function () {
        return _this.loading = false;
      });
    }
  }
};